import axios from 'axios';

// Determine if we're in local development
const isLocalDevelopment = window.location.hostname === 'localhost' ||
  window.location.hostname === '127.0.0.1' ||
  window.location.hostname.startsWith('192.168.');

let productUrl;
let notificationUrl;

if (isLocalDevelopment) {
    // Local development URLs
    productUrl = 'https://product.hertex-staging.net/';
    notificationUrl = 'https://notification.hertex.co.za/';
} else {
    // Production URLs - dynamically constructed from current domain
    const origin = window.location.origin;
    const cleanUrl = origin.replace(/^https?:\/\/(www\.)?/, '');

    productUrl = `https://product.${cleanUrl}/`;
    notificationUrl = `https://notification.${cleanUrl}`;
}

export const baseURL = axios.create({
    baseURL: productUrl,
});

export const baseNotificationURL = axios.create({
    baseURL: notificationUrl,
});